import { BrandCode } from './curriculum';

type CurriculumConfig = {
  timelineEnabledCurriculum: BrandCode[];
  overviewEnabledCurriculum: BrandCode[];
  standardCurriculumLines: BrandCode[];
  previewRestrictions: Partial<Record<BrandCode, ('distribute' | 'reschedule')[]>>;
};
export const curriculumConfig: CurriculumConfig = {
  timelineEnabledCurriculum: ['HYFI', 'HYFICHRISTMAS'],
  overviewEnabledCurriculum: ['HYFI'],
  standardCurriculumLines: ['TGP', 'ETB', 'BSFL', 'HYFI', 'YOU'],
  previewRestrictions: {
    HYFICHRISTMAS: ['reschedule'],
  },
};
